module.exports = __webpack_public_path__ + "img/dealer-icon-4.c4cc9f71.png";